import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock, Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user?.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Connexion réussie");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-5 bg-[#050505] grain relative">
      <div className="relative z-10 w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 text-sm text-neutral-500 hover:text-white mb-8"><ArrowLeft className="h-4 w-4" /> Retour au site</Link>
        <div className="bg-[#121212] border border-white/10 rounded-sm p-8 lg:p-10">
          <img src="/logo.png" alt="AS AUTO Garage" className="h-20 w-auto object-contain -ml-1 mb-2" />
          <h1 className="font-display text-2xl font-bold text-white flex items-center gap-2"><Lock className="h-5 w-5 text-[#C5A059]" /> Espace administrateur</h1>
          <p className="text-sm text-neutral-500 mt-2">Connectez-vous pour gérer vos véhicules et demandes.</p>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <Label className="text-neutral-300 mb-1.5 block text-sm">E-mail</Label>
              <Input data-testid="admin-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="bg-[#0a0a0a] border-white/15 text-white focus-visible:ring-[#C5A059]" />
            </div>
            <div>
              <Label className="text-neutral-300 mb-1.5 block text-sm">Mot de passe</Label>
              <Input data-testid="admin-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="bg-[#0a0a0a] border-white/15 text-white focus-visible:ring-[#C5A059]" />
            </div>
            <Button data-testid="admin-login-btn" type="submit" disabled={loading} className="w-full bg-[#C5A059] text-black hover:bg-[#E6C678] rounded-sm h-11 font-semibold">
              {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} Se connecter
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
